import React, { useState } from 'react'

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import format from 'date-fns/format'
import { useCustomerCodeCheck } from 'features/customers/hooks/useCustomerCodeCheck'

import { YesNo } from 'components/_base'

const CustomerCodeCheck = () => {
  const { data } = useCustomerCodeCheck()
  const [open, setOpen] = useState(false)

  const timestamp = data?.timestamp

  return (
    <>
      <Button onClick={() => setOpen(true)}>Check code status</Button>

      <Dialog onClose={() => setOpen(false)} open={open}>
        <DialogTitle>Tracking Script Status</DialogTitle>

        <DialogContent style={{ width: 500 }}>
          <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
            Code installed: <YesNo value={!!timestamp} />
          </Box>
          <p>{`Last event: ${timestamp ? format(timestamp, 'yyyy-MM-dd HH:mm:ss') : '–'}`}</p>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default CustomerCodeCheck
